var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { onePxThick } from "@irati/ui/src/global/elevation";
import { Lato, LatoBold } from "@irati/ui/src/global/fonts";
export var TagCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  border-radius: 81px;\n  padding: 10px 30px;\n  margin: 5px 10px 10px 1px;\n  text-align: center;\n  text-transform: uppercase;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  letter-spacing: 0.2px;\n\n  ", "\n  ", "\n\n  &:hover {\n    cursor: pointer;\n  }\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: inline-block;\n  border-radius: 81px;\n  padding: 10px 30px;\n  margin: 5px 10px 10px 1px;\n  text-align: center;\n  text-transform: uppercase;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  letter-spacing: 0.2px;\n\n  ", "\n  ", "\n\n  &:hover {\n    cursor: pointer;\n  }\n  &:focus {\n    outline: none;\n  }\n"])), function (_a) {
    var tag = _a.tag;
    return tag ? "10px" : "12px";
}, function (_a) {
    var tag = _a.tag;
    return tag ? "12px" : "16px";
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected ? theme.colors.greys.white : theme.colors.greys.black;
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected ? theme.colors.greys.mediumDark : theme.colors.greys.white;
}, function (_a) {
    var light = _a.light;
    return light ? Lato : LatoBold;
}, onePxThick);
export var TagElement = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TagCss);
var templateObject_1, templateObject_2;
